const boeTaskEn = {
  components: {
    approvalActions: {
      approvalCompleted: 'Approval completed',
      remandCompleted: 'Sent back to the applicant'
    },
    approvalRecallDialog: {
      action: 'Recall',
      cancel: 'Cancel',
      description: 'The request will come back to you so you can edit it, and the approval in progress will start over. Do you want to recall it?',
      submit: 'Recall',
      submitting: 'Recalling...',
      success: 'The request has been recalled',
      title: 'Recall this request'
    },
    approvalReturn: {
      banner: {
        description: 'Please correct the content and submit it again. The reason given by the approver is shown below.',
        emptyReason: '(No reason provided)',
        sentBackCount: 'Sent back {{count}} time(s)',
        title: 'Your request was sent back'
      },
      history: {
        count: '{{count}} item(s)',
        emptyReason: '(No reason provided)',
        hideMore: 'Hide history',
        kindRecalled: 'Pulled back',
        kindSentBack: 'Sent back',
        showMore: 'Show past history ({{count}})',
        title: 'Send-back and pull-back history',
        unknownOperator: '(Unknown)'
      }
    },
    approvalReturnPolicyRule: {
      allowRecallLabel: 'Allow recall',
      allowSendBackLabel: 'Allow send-back'
    },
    approvalSendBackDialog: {
      cancel: 'Cancel',
      description: 'The applicant will be able to edit and resubmit the request. Entering a reason is optional.',
      placeholder: 'Enter the reason for sending back (optional)',
      submit: 'Send back',
      submitting: 'Sending back...',
      success: 'The request has been sent back to the applicant',
      title: 'Send back to the applicant'
    },
    approvalStageRule: {
      fieldTitle: 'Number of Approval Stages',
      stageLabel: '{{count}} stage'
    },
    approvalTaskConfig: {
      buttonSave: 'Save',
      saveFailed: 'Failed to save configuration',
      saveSuccess: 'Configuration saved successfully',
      stageNotificationName: '{{taskName}} (Stage {{count}})',
      stageNotificationUnsavedHint: 'Available after saving the approval flow',
      validationErrorAllStages: 'Please set a People Group for all approval stages'
    },
    approvalTaskDetail: {
      noSubmissionContent: 'No submission content',
      noSubmissionFields: 'No submission fields'
    },
    confirmationTask: {
      confirm: 'Confirm',
      confirming: 'Confirming...',
      disabledReason: {
        notInProgress: 'This action is unavailable because the task is not in progress.'
      },
      errors: {
        conflict: 'The action failed due to a concurrent update. Please refresh and try again.',
        forbidden: 'You do not have permission to perform this action.',
        notFound: 'The task could not be found. Please refresh or reopen it from the list.'
      },
      return: 'Return',
      returnDialog: {
        cancel: 'Cancel',
        description: 'Please enter the reason for returning this task.',
        placeholder: 'Enter comment (optional)',
        submit: 'Return',
        title: 'Return Task'
      },
      returnHistory: {
        emptyComment: '(No comment)',
        hasReturnHistory: 'Return history: {{count}}',
        hideMore: 'Hide history',
        latestTitle: 'Latest return comment',
        showMore: 'Show past history ({{count}})',
        unknownOperator: '(Unknown)'
      },
      returning: 'Returning...'
    },
    displayNameEditDialog: {
      descriptionLabel: 'Description',
      descriptionMaxLength: 'Description must be within 500 characters',
      descriptionPlaceholder: 'Enter a description (leave blank to remove it)',
      editNameAndDescriptionTooltip: 'Edit name and description',
      editNameAriaLabel: 'Edit task name',
      editNameTooltip: 'Edit name',
      editPatternAriaLabel: 'Edit procedure name and description',
      editStepNameAriaLabel: 'Edit step name and description',
      editTaskDisplayAriaLabel: 'Edit task name and description',
      nameLabel: 'Name',
      nameMaxLength: 'Name must be within 100 characters',
      namePlaceholder: 'Enter a name',
      nameRequired: 'Please enter a name',
      patternNotice: 'The change appears immediately on the settings screen, the procedure list, and the employee request menu. Procedures already in progress keep the name and description from when they started.',
      patternNoticeDraft: 'Changes take effect after you save this screen. Procedures already in progress keep the name and description from when they started.',
      patternTitle: 'Edit Procedure Name and Description',
      saveDescriptionSuccess: 'Description updated',
      saveSuccess: 'Renamed to "{{name}}"',
      stepNameTitle: 'Edit Step Name',
      stepNotice: 'The change applies only to procedures started after saving. Procedures already in progress keep the step name and notification text from when they started.',
      stepNoticeDraft: 'The change applies only to procedures started after you save this screen. Procedures already in progress keep the step name and notification text from when they started.',
      stepTitle: 'Edit Step Name and Description',
      taskNotice: 'The change applies only to procedures started after saving. Procedures already in progress keep the name from when they started.',
      taskNoticeDraft: 'The change applies only to procedures started after you save this screen. Procedures already in progress keep the name from when they started.',
      taskTitle: 'Edit Task Name',
      taskWithDescriptionTitle: 'Edit Task Name and Description'
    },
    freeFormTaskConfig: {
      addOption: 'Add option',
      addOther: 'Add "Other"',
      addQuestion: 'Add question',
      answerRequired: 'Please provide an answer',
      descriptionPlaceholder: 'Supplementary description',
      emptyOptionLabel: 'Enter the option label',
      optionPlaceholder: 'Option {{index}}',
      or: 'or',
      otherAnswerPlaceholder: 'Enter details',
      otherOptionLabel: 'Other',
      otherTextRequired: 'Please enter details for "Other"',
      questionDeleted: 'Question deleted',
      questionLimit: 'You can add up to 10 questions.',
      questionsDescription: 'Add supplementary text as needed',
      questionsTitle: 'Questions',
      required: 'Required',
      textAnswerPlaceholder: 'Text answer',
      textAreaAnswerPlaceholder: 'Long text answer',
      titlePlaceholder: 'Title',
      typeCheckbox: 'Checkbox',
      typeRadio: 'Radio button',
      typeText: 'Short text',
      typeTextArea: 'Long text',
      undo: 'Undo'
    },
    labelTask: {
      helpTooltipLabel: 'Task generation information'
    },
    nodeConfirmationToggle: {
      error: {
        disableFailed: 'Failed to disable confirmation task',
        enableFailed: 'Failed to enable confirmation task'
      },
      label: 'Confirmation task',
      success: {
        disabled: 'Confirmation task disabled',
        enabled: 'Confirmation task enabled'
      }
    },
    notificationConfigDialog: {
      body: {
        label: 'Message',
        placeholder: 'Enter the message body',
        required: 'Please enter the message body'
      },
      description: 'Set when, to whom, and what to notify for "{{name}}".',
      errors: {
        saveFailed: 'Failed to save the notification settings'
      },
      recipients: {
        label: 'Recipients',
        options: {
          assignee: 'Assignee',
          operator: 'Operator'
        },
        required: 'Please select at least one recipient'
      },
      subject: {
        description: 'Used only by notification channels that support a subject, such as email.',
        label: 'Subject',
        placeholder: 'Enter the subject'
      },
      title: 'Notification Settings',
      trigger: {
        contentNotCreated: 'Message not set',
        description: 'Arrival and leave notifications are configured separately in each tab. Saving applies both tabs, and a disabled timing has its saved settings removed.',
        disabled: 'Disabled',
        enabled: 'Enabled',
        label: 'Timing',
        options: {
          arrive: 'When the task arrives',
          leave: 'When the task leaves'
        },
        toggleLabel: 'Enable this notification'
      },
      variables: {
        groupFlowCommon: 'Flow common',
        insert: 'Insert variable',
        notFound: 'No variables found',
        searchPlaceholder: 'Search variables'
      }
    },
    notificationRule: {
      fieldTitle: 'Notification',
      statusOff: 'Off',
      statusOn: 'On'
    },
    operationTaskActionButton: {
      defaultActionButtonText: 'Execute'
    },
    peopleGroupEditDialog: {
      buttonCancel: 'Cancel',
      buttonClose: 'Close',
      buttonSave: 'Save',
      descriptionEdit: 'You can edit the group information for the approval flow.',
      descriptionReadOnly: 'Displaying group information for the approval flow.',
      groupLabel: 'Group *',
      groupRequired: 'Please select a group',
      groupSelectPlaceholder: 'Select a group',
      groupUnset: 'Group is not set',
      stageNameDescription: 'Leave blank to keep the current stage name.',
      stageNameLabel: 'Stage name',
      stageNamePlaceholder: 'Use the default stage name',
      titleEdit: 'Edit Group',
      titleReadOnly: 'Group Information'
    },
    personEditDialog: {
      buttonCancel: 'Cancel',
      buttonClose: 'Close',
      buttonSave: 'Save',
      descriptionEdit: 'You can edit the person information for the approval flow.',
      descriptionReadOnly: 'Displaying person information for the approval flow.',
      personLabel: 'Person *',
      personRequired: 'Please select a person',
      titleEdit: 'Edit Person',
      titleReadOnly: 'Person Information'
    },
    stepContainer: {
      description: 'Description',
      disabledTooltip: 'This field cannot be edited at this time'
    },
    taskConfigHeader: {
      approvalWorkflowTitle: 'Approval workflow'
    },
    taskConfigItems: {
      buttonAdd: 'Add',
      buttonEdit: 'Edit',
      buttonView: 'View',
      disable: {
        error: {
          lastItem: 'Cannot disable the last item',
          missingInfo: 'Task information is missing',
          operationFailed: 'Operation failed',
          systemRequired: 'System required items cannot be disabled',
          title: 'Failed to disable'
        },
        success: {
          description: '{{name}} has been disabled',
          title: 'Disabled successfully'
        }
      },
      enable: {
        error: {
          missingInfo: 'Task information is missing',
          title: 'Failed to enable'
        },
        success: {
          description: 'Item has been enabled',
          title: 'Enabled successfully'
        }
      },
      notInUseTitle: 'Not in use',
      tooltip: {
        systemRequired: 'System required items cannot be disabled'
      },
      tooltipRemove: 'Do not use this task'
    },
    taskDialog: {
      checklist: 'Checklist',
      checklistCompletionHint: 'Complete all checklist items to mark this task as complete',
      formInfoNotAvailable: 'Form information could not be retrieved',
      formNotRequired: 'This task cannot be completed from this screen. Please use the dedicated task operation.',
      markAsComplete: 'Mark as complete',
      processing: 'Processing...',
      receiveDetailError: 'Could not load Receive task details',
      receiveDetailLoading: 'Loading details…',
      receiveLastSyncedAtLabel: 'Last synced',
      receiveLastSyncedAtNone: '—',
      receiveNotStartedHint: 'This task has not started yet. Sync and withdraw are available after it starts.',
      receiveOperationUnavailable: 'This operation cannot be performed. Please try again later.',
      receiveResolvedStatusCompletedBySync: 'Completed by sync',
      receiveResolvedStatusLabel: 'Resolved status (sync)',
      receiveResolvedStatusPending: 'Pending',
      receiveResolvedStatusReturnedBySync: 'Returned by sync',
      receiveResolvedStatusUnknown: '—',
      receiveSync: 'Sync',
      receiveWithdraw: 'Withdraw',
      receiveWithdrawConfirmDescription: 'This will withdraw the task. Are you sure?',
      receiveWithdrawConfirmOk: 'Withdraw',
      receiveWithdrawConfirmTitle: 'Confirm withdrawal',
      save: 'Save',
      saving: 'Saving...',
      taskCompleted: 'This task is completed'
    },
    todoChecklistEditDialog: {
      addItemButton: 'Add Item',
      checklistLabel: 'Checklist',
      description: 'Please edit the TODO.',
      descriptionLabel: 'Description',
      descriptionMaxLength: 'Description must be within 500 characters',
      descriptionPlaceholder: 'Enter description',
      displayNameLabel: 'Display Name',
      displayNameMaxLength: 'Display name must be within 100 characters',
      displayNamePlaceholder: 'Enter display name',
      displayNameRequired: 'Please enter TODO display name',
      itemPlaceholder: 'Enter checklist item',
      noItemsMessage: 'No checklist items. Please add items using the "Add Item" button.',
      title: 'Edit TODO'
    },
    todoTaskConfig: {
      editButton: 'Edit',
      notSet: 'TODO is not set.',
      pleaseSetTodo: 'Please set TODO.'
    }
  },
  returnedCommentBanner: {
    emptyComment: '(No comment)',
    sentBackCount: 'Sent back {{count}} time(s)',
    title: 'Task was returned'
  }
};
export default boeTaskEn;